import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a037bf5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "description" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("h1", { id: "description_title" }, "Order details")
], -1))
const _hoisted_3 = { id: "description_text" }
const _hoisted_4 = {
  key: 0,
  id: "finaltext"
}
const _hoisted_5 = { id: "order_title" }
const _hoisted_6 = { id: "order_description" }
const _hoisted_7 = {
  key: 1,
  class: "ph-item"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"ph-col-12\" data-v-5a037bf5><div class=\"ph-row\" data-v-5a037bf5><div class=\"ph-col-6 big\" style=\"margin-bottom:0.7rem;\" data-v-5a037bf5></div><div class=\"ph-col-12\" data-v-5a037bf5></div><div class=\"ph-col-8\" data-v-5a037bf5></div><div class=\"ph-col-4 empty\" data-v-5a037bf5></div></div></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]

import CheckoutForm from '@/components/purchase/CheckoutForm.vue';
import axios from 'axios';
import { onMounted, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const isLoading = ref(false);

onMounted(() => {
  isLoading.value = true;
  setTimeout(() => {
    isLoading.value = false;
  }, 2000);
});

const state = reactive({
  title: '',
  description: '',
  price: '',
});

// let resiRes: Record<string, unknown> = {};
// let dediRes: Record<string, unknown> = {};

if (route.query.type === 'new_datacenter_shared') {
  const getPremiun = () => {
    const url = `https://api.proxyscrape.com/v2/order/create?getdetails=true&type=${route.query.type}&proxies[${route.query.proxies}]=${route.query.title}&price_version=pt4_2`;
    axios.get(url).then((data) => {
      // console.log(data.data);
      state.title = data.data.title;
      state.description = data.data.description;
      state.price = data.data.price;
    });
  };
  getPremiun();
} else if (route.query.type === 'beta_new_residential') {
  const getResidential = () => {
    const url = `https://api.proxyscrape.com/v2/order/create?getdetails=true&type=${route.query.type}&bandwidth=${route.query.bandwidth}&price_version=pt4_2`;
    axios.get(url).then((data) => {
      // console.log(data.data);
      state.title = data.data.title;
      state.description = data.data.description;
      state.price = data.data.price;
    });
  };
  getResidential();
} else if (route.query.type === 'beta_new_dedicated') {
  const getDedicated = () => {
    const url = `https://api.proxyscrape.com/v2/order/create?getdetails=true&type=${route.query.type}&proxies=${route.query.proxies}&price_version=pt4_2`;
    axios.get(url).then((data) => {
      // console.log(data.data);
      state.title = data.data.title;
      state.description = data.data.description;
      state.price = data.data.price;
    });
  };
  getDedicated();
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createTextVNode(_toDisplayString(_unref(route).query.id) + " ", 1),
    _createElementVNode("div", null, [
      _createVNode(CheckoutForm, {
        totalPrice: _unref(state).price
      }, null, 8, ["totalPrice"]),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(state).title), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(state).description), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        ])
      ])
    ])
  ]))
}
}

})